<script lang="ts">
    export let retry: () => void;
    export let reason: string;
</script>

<div class="wrapper">
    Generation was denied<br />
    <div class="error">{reason}</div>
    <button on:click={retry}>try with a different prompt</button>
</div>

<style>
    .wrapper {
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        gap: 0.5rem;
    }
    .error {
        color: red;
        font-weight: bold;
    }
</style>
